import { CreatableDropdown } from 'components/CreatableDropdown/CreatableDropdown';
import { setAccessToEdit } from 'features/access/accessStateSlice';
import { useGetVendorsQuery } from 'features/vendor/vendorSlice';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const VendorFields = ({ }) => {
    let { data: vendors, error: vendorsError, isLoading: isLoadingVendors } = useGetVendorsQuery();
    vendors = vendors || []

    const [newVendor, setNewVendor] = useState(null)

    if (newVendor) { vendors = [...vendors, newVendor] }

    const { accessToEdit } = useSelector(state => state.accessState);
    const dispatch = useDispatch();

    const onChangeValue = (key, val) => {
        dispatch(setAccessToEdit({ ...accessToEdit, [key]: val }))
    }

    const onAddVendor = async (val) => {
        setNewVendor({ ...val, id: 0 });
        onChangeValue("vendorName", val.name)
    }

    return (
        <>
            <CreatableDropdown
                options={vendors}
                value={accessToEdit?.vendorId}
                required
                addValue={onAddVendor}
                label='Vendor Name'
                onChange={(val) => onChangeValue("vendorId", val)}
            />
        </>
    );
}

export default VendorFields;